import React, { useState, useRef, useContext } from 'react'
import VideoItem from "../Home/VideoItem"
import ReactTooltip from "react-tooltip";
import "../Home/VideoCarousel.css"
import { GlobalContext } from '../../Context/GlobalContext';
import PremieredVideoItem from '../Home/PremieredVideoItem';
import { validateExpirationDate } from '../../utils/handlePremiereDates';

const PlaylistIcon = ({ onClick }) => (
  <>
    <i onClick={onClick} className="fas fa-play-circle ml-3" data-tip data-for="GoToPlayList"></i>
    <ReactTooltip id="GoToPlayList" type="dark" effect="solid" place="right">
      <span>Go to Playlist</span>
    </ReactTooltip>
  </>
);


const VideoCarousel = ({ 
  contents,
  title,
  isAPlaylist, 
  videos, 
  category,
  headerInsert,
  setFile,
  setPlaylist,
  color 
}) => {

  const carousel = useRef();
  const [loading, setLoading] = useState(false);
  const {darkMode} = useContext(GlobalContext)
  const clickButtonLeft = () => {
    if(!carousel.current) return

    if (carousel.current.scrollLeft === 0) {
      carousel.current.scroll({
        left: carousel.current.scrollWidth - carousel.current.clientWidth,
        top: 0,
        behavior: "smooth",
      });
    } else {
      carousel.current.scroll({
        left: carousel.current.scrollLeft - carousel.current.clientWidth / 2,
        top: 0,
        behavior: "smooth",
      });
    }
  }

  const clickButtonRight = () => {
    if(!carousel.current) return;

    if (carousel.current.scrollWidth === carousel.current.scrollLeft + carousel.current.clientWidth) {
      carousel.current.scroll({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    } else {
      carousel.current.scroll({
        left: carousel.current.scrollLeft + carousel.current.clientWidth / 2,
        top: 0,
        behavior: "smooth",
      });
    }
  }
  const constructVideoItems = () => {

    if(!videos) return [];
    
    if(category === "recent") {
      // only display the first 12 videos
      videos = videos.slice(0, 12);
    }

    return videos.map(item => {
      if(!item || !category) return "";

      let onClick, previewSpecial;
      let previewType = category;
      switch(category) {
        case "live":
          if(!item.type) {
            item.type = "live"
          }
          previewSpecial = true
          onClick = (notAccessible) => {setFile(item, [], "live", notAccessible)};
          break
        case "playlists":
          if(!item.type) {
            item.type = "playlist"
          }
          onClick = (notAccessible) => {
            if(item.videos) {
              setFile(item.videos[0], item.videos, "playlist", notAccessible);
            } else {
              setFile(item.name, [], "playlist-first", notAccessible);
            }
          }
          previewSpecial = true
          break
        default:
          if(!item.type) {
            item.type = "video"
          }
          onClick = (notAccessible) => {
            setFile(item, videos, "playlist", notAccessible);
          }
          break
      }
      if (validateExpirationDate(item?.premiereDate)) {
        return <PremieredVideoItem videoObj={item}/>
      }
      return <VideoItem 
                key={item._id}
                item={item}
                onClick={onClick}
                category={previewType}
                color={color}
                previewSpecial={previewSpecial}/>

    })
  }
  
  if(!contents) {
    if(videos) {
      contents = constructVideoItems()
    } else {
      contents = []
    }
  }


  return (
    <>
      {!loading && 
        <div className={(contents.length > 0 || loading) ? "" : "d-none"}>

        <div className="flex-row">
          <div className="home-section-header" >
            {title}
            {isAPlaylist && <PlaylistIcon onClick={() => setPlaylist(videos, category)}/>}
          </div>
          {headerInsert}
        </div>

        <div className={loading ? "mb-3 carouselLoader" : "d-none"}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <span>Loading Contents...</span>
        </div>

        <div className={(contents.length > 0) ? "home-row-wrapper" : "d-none"}>
          <div className={darkMode?"dark row-btn-left":"row-btn-left"} onClick={clickButtonLeft}>
            <i className={darkMode?"dark fas fa-chevron-left":"fas fa-chevron-left"}></i>
          </div>

          <div className=" mb-3 border-bottom home-page-row" ref={carousel}>
            {contents}
            <div className="col-3 mb-3" />
          </div>

          <div className={darkMode?"dark row-btn-right":"row-btn-right"} onClick={clickButtonRight}>
            <i className={darkMode?"dark fas fa-chevron-right":"fas fa-chevron-right"}></i>
          </div>
        </div>

      </div>
      }
    </>
  )
  
}

export default VideoCarousel;

